module.exports = __webpack_public_path__ + "static/media/sub.cddeaa8a.jpg";